module.exports = __webpack_public_path__ + "img/not-supported-icon.20236644.svg";